const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_unauthed/auth/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_unauthed/auth')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});